import { Controller } from '@hotwired/stimulus';

// Toggles a password field between hidden and visible.
//
// Usage:
//   <span class="input" data-controller="password-visibility">
//     <input type="password" data-password-visibility-target="input">
//     <button type="button" class="input__eye" data-action="password-visibility#toggle">
//       <span data-password-visibility-target="show">...eye...</span>
//       <span data-password-visibility-target="hide" hidden>...eye-off...</span>
//     </button>
//   </span>
export default class extends Controller {
  static targets = ['input', 'show', 'hide'];

  toggle() {
    const revealed = this.inputTarget.type === 'text';
    this.inputTarget.type = revealed ? 'password' : 'text';
    if (this.hasShowTarget) this.showTarget.hidden = !revealed;
    if (this.hasHideTarget) this.hideTarget.hidden = revealed;
  }
}
